import React from "react";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
const Table = ({ data ,onView}) => {
  return (
    <div className="overflow-x-auto">
      <table className="table-auto w-full border-collapse border border-gray-200">
        <thead>
          <tr className="bg-gray-100">
            {[
                  "Signage ID",
                  "Signage Type" ,
                  "Height",
                  "Width",
                  "Recce Pdf",
                  "Admin Status",
                  "Client Status",
                  "Ip Name",
                  "Creation Date",
                  "Approve By",
                  "Approval Date",
                    "Actions"
            ].map((header, index) => (
              <th
                key={index}
                className="border border-gray-300 px-4 py-2 text-left"
              >
                {header}
                <input
                  className="block mt-1 w-full border rounded px-2 text-sm"
                  type="text"
                  placeholder="Search"
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={rowIndex % 2 === 0 ? "bg-gray-50" : "bg-white"}
            >
              <td className="border border-gray-300 px-4 py-2">{row.signageID || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.signageType || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.height || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.width || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.reccepdf || "Na"}</td>

              <td className="border border-gray-300 px-4 py-2">
                <span
                  className={`px-2 py-1 rounded ${
                    row.adminStatus === "APPROVED"
                      ? "bg-green-100 text-green-600"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  {row.adminStatus || "Na"}
                </span>
              </td>
              <td className="border border-gray-300 px-4 py-2">
                <span
                  className={`px-2 py-1 rounded ${
                    row.clientStatus === "SENT"
                      ? "bg-green-100 text-green-600"
                      : "bg-red-100 text-red-600"
                  }`}
                >
                  {row.clientStatus || "Na"}
                </span>
              </td>
              <td className="border border-gray-300 px-4 py-2">{row.creator || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.creationDate || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">{row.approver || "Na"}</td>
              <td className="border border-gray-300 px-4 py-2">
                {row.approvalDate || "Na"}
              </td>
              <td className="border border-gray-300 px-4 py-2">
              <button
                onClick={() => onView(row)} // Trigger modal with row data
                className="text-blue-500 hover:text-blue-700"
              >
                <RemoveRedEyeOutlinedIcon size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
